import { render, staticRenderFns } from "./ItemSource.vue?vue&type=template&id=bfc5181e&"
import script from "./ItemSource.vue?vue&type=script&lang=js&"
export * from "./ItemSource.vue?vue&type=script&lang=js&"
import style0 from "./ItemSource.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports